import React, { useId } from 'react';
import { Box, Button, Group, Text } from '@mantine/core';
import ImagePointSurface from './ImagePointSurface';
import styles from './ImageFocalPointPicker.module.css';

export default function ImageFocalPointPicker({ src, value, onChange, onDone }) {
  const descriptionId = useId();
  return (
    <Box className={styles.panel}>
      <Text size="xs" fw={600}>Cadrage de l’image</Text>
      <Text id={descriptionId} size="xs" c="dimmed" mt={4} mb="sm">
        Cliquez sur le sujet à garder visible ou déplacez le repère.
      </Text>
      <ImagePointSurface src={src} value={value} onChange={onChange} onDone={onDone} autoFocus={typeof onDone === 'function'} descriptionId={descriptionId} label="Choisir le point d’intérêt de l’image" />
      <Text size="xs" c="dimmed" mt="sm">
        Le cadrage s’ajuste directement sur la page.
      </Text>
      <Group justify="space-between" gap="xs" mt="sm">
        <Button size="compact-xs" variant="subtle" onClick={() => onChange({ x: 50, y: 50 })}>
          Recentrer
        </Button>
        {onDone && <Button size="compact-xs" onClick={onDone}>Terminer</Button>}
      </Group>
    </Box>
  );
}
